import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import MuniDetail from "./pages/MuniDetail"; // Create MuniDetail component
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Account from "./pages/Account";
import { AuthContextProvider, UserAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ForgotPassword from "./pages/ForgotPassword";
import Footer from "./components/Footer";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";
import SystemRequirements from "./pages/SystemRequirements";
import ScrollToTop from "./components/ScrollToTop";
import Faq from "./pages/Faq";
import Admin from "./pages/Admin";
import Forbidden from "./pages/Forbidden";
import { ContentProvider } from "./context/ContentContext";
import { SavedSeriesProvider } from "./context/SavedSeriesContext";
import NotFound from "./pages/NotFound";
import SeriesProtectedRoute from "./components/SeriesProtectedRoute";
import PasswordModal from "./components/PasswordModal";
import { PasswordProvider } from "./context/PasswordContext";
import PasswordRoute from "./components/PasswordRoute"; // Assuming you created a new file for PasswordRoute
import { TranslationProvider } from "./hooks/useTranslation";


const AdminCheckRoute = ({ element }) => {
  const { user, isAdmin, loading } = UserAuth();

  if (loading) return <div>Loading...</div>; // Prevents redirecting too soon
  if (!user || !isAdmin) return <Navigate to="/forbidden" />;

  return element;
};

function App() {
  const location = useLocation();
  const isScoreboard = location.pathname === "/scoreboard";

  return (
      <AuthContextProvider>
        <TranslationProvider>
        <ContentProvider>
          <SavedSeriesProvider>
            <PasswordProvider>
              {!isScoreboard && <Navbar />}
              {!isScoreboard && <ScrollToTop />}
              {!isScoreboard && <PasswordModal />}
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route
                  path="/account"
                  element={
                    <ProtectedRoute>
                      <Account />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/series/:seriesId"
                  element={
                    <SeriesProtectedRoute>
                      <MuniDetail />
                    </SeriesProtectedRoute>
                  }
                />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<Faq />} />
                <Route
                  path="/admin"
                  element={<AdminCheckRoute element={<Admin />} />}
                />
                <Route
                  path="/systemrequirements"
                  element={<SystemRequirements />}
                />
                <Route path="/password" element={<PasswordRoute />} />
                <Route path="/forbidden" element={<Forbidden />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
              {!isScoreboard && <Footer />}
            </PasswordProvider>
          </SavedSeriesProvider>
        </ContentProvider>
        </TranslationProvider>
      </AuthContextProvider>
  );
}

export default App;
